function getComp(name) {
  return import(
    `./${name}.vue`
  );
}

export const route = {
  path: '/myApplicationList',
  name: 'myApplicationList',
  component: getComp.bind(null, 'MyApplicationList'),
  meta: {
    matchNav: 'myApplicationList',
  },
  // children: [{
  //     path: 'teamBudget',
  //     name: 'budgetManage.teamBudget',
  //     component: getComp.bind(null, 'TeamBudget'),
  //     meta: {
  //       matchNav: 'budgetManage.teamBudget',
  //     },
  //   },
  // ],
};